import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const NotificationsWrapper = styled.div`
  position: absolute;
  right: -1px;
  top: 50px;
  background-color: #fff;
  border: 1px solid #bdbdbd;
  width: 440px;
  height: 508px;
  overflow: auto;
  border-top-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 2px 4px 8px rgba(160, 160, 160, 0.35);
  padding: 10px 10px 45px 10px;
  opacity: 0;
  visibility: hidden;
  transition: 0.1s ease-in-out;
  z-index: -1;

  &::-webkit-scrollbar {
    display: none;
  }

  &.active {
    opacity: 1;
    visibility: visible;
  }

  &::after,
  &::before {
    bottom: 100%;
    right: 22px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #ffffff;
    border-width: 6px;
    margin-right: 0px;
  }

  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #bdbdbd;
    border-width: 8px;
    margin-right: -2px;
  }

  ${mediaMaxWidth.tablet`
    width: 100vw;
    height: ${(props) =>
      props.iOS ? "calc(100vh - 130px)" : "calc(100vh - 116px)"};
    right: -71px;
    border-radius: 0;
  `}
`;

export const Header = styled.div`
  position: fixed;
  height: 45px;
  background: #fff;
  width: 438px;
  margin: -10px 0 0 -10px;
  padding: 10px;
  border-bottom: 1px solid #bdbdbd;
  letter-spacing: 0.02em;
  font-weight: 700;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaMaxWidth.tablet`
    width: 100%;
  `}
`;

export const MarkAsRead = styled.a`
  text-decoration: underline !important;
  font-size: 0.9em;
  color: #333 !important;
  letter-spacing: 0.02em;
  font-weight: 400;

  &:hover {
    color: #79D9D9 !important;
  }
`;

export const ItemsWrapper = styled.ul`
  list-style: none;
  padding: 45px 0 0 0;
  margin: 0;
`;

export const Item = styled.li`
  margin: 5px 0;

  &:first-child {
    margin: 0 0 5px 0;
  }

  &:last-child {
    margin: 5px 0 0 0;
  }
`;

export const AboutNotification = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const BodyWrapper = styled.div`
  display: flex;
  width: 290px;
  flex-direction: column;

  ${mediaMaxWidth.tablet`
    flex: 1;
    width: unset;
  `}
`;

export const Subject = styled.div`
  font-size: 0.95em;
  font-weight: 600;
  color: #333333;
  opacity: 0.8;
  letter-spacing: 0.015em;
  width: 285px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.phone`
    padding-left: 5px;
    font-size: 0.8em;
    width: 220px;
  `}

  ${mediaMaxWidth.smallPhone`
    padding-left: 0;
    width: 175px;
  `}
`;

export const NotificationText = styled.div`
  font-size: 1em;
  color: #333333;
  opacity: 0.6;
  font-style: italic;
  letter-spacing: 0.015em;
  line-height: 1.3em;
  word-break: break-word;
  padding-top: 5px;
  width: 295px;

  ${mediaMaxWidth.phone`
    padding-left: 5px;
    font-size: 0.85em;
    width: 260px;
  `}

  ${mediaMaxWidth.smallPhone`
    padding-left: 0;
    font-size: 0.7em;
    width: 190px;
  `}
`;

export const Time = styled.div`
  font-size: 0.95em;
  width: 50px;
  font-style: italic;
  padding-top: 3px;
  letter-spacing: 0.015em;
  text-align: right;
  color: #333333;
  opacity: 0.6;
  position: absolute;
  right: 20px;

  ${mediaMaxWidth.phone`
    font-size: 0.85em;
    padding-top: 0;
  `}

  ${mediaMaxWidth.smallPhone`
    position: relative;
    left: -5px;
  `}
`;

export const NotificationLink = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 81px;
  color: #333 !important;
  padding: 7px 10px 10px 10px;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #eee;

  &:hover {
    background-color: #fbfbfb;

    ${mediaMaxWidth.tablet`
      width: calc(100% + 4px);
    `}
  }

  &.read-false {
    background-color: #402680;

    i {
      color: #fff;
    }

    ${Subject} {
      color: #fff;
      opacity: 1;
    }

    ${NotificationText},
    ${Time} {
      color: #fff;
      opacity: 0.7;
    }
  }
`;

export const IconWrapper = styled.div`
  width: 55px;

  ${mediaMaxWidth.phone`
    width: 40px;
  `}
`;

export const NotificationIcon = styled.i`
  padding-top: 5px;

  &.fa-file-alt,
  &.fa-calendar-alt {
    font-size: 1.8em !important;
  }

  &.fa-star,
  &.fa-exchange-alt,
  &.fa-envelope,
  &.fa-hands-helping,
  &.fa-pencil-alt,
  &.fa-users,
  &.fa-calendar-alt,
  &.fa-user-friends,
  &.fa-phone,
  &.fa-thumbs-up,
  &.fa-thumbs-down {
    font-size: 1.6em !important;
  }

  &.notification {
    height: 50px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;

    ${mediaMaxWidth.phone`
      &.fa-file-alt,
      &.fa-calendar-alt {
        font-size: 1.5em !important;
      }

      &.fa-star,
      &.fa-exchange-alt,
      &.fa-hands-helping,
      &.fa-pencil-alt,
      &.fa-users,
      &.fa-user-friends,
      &.fa-phone,
      &.fa-thumbs-up,
      &.fa-thumbs-down {
        font-size: 1.3em !important;
      }
    `}
  }
`;

export const Footer = styled.div`
  position: fixed;
  top: 518px;
  background: #fff;
  height: 45px;
  width: 438px;
  padding: 10px;
  margin-left: -10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${mediaMaxWidth.tablet`
    top: ${(props) =>
      props.iOS ? "calc(100vh - 120px)" : "calc(100vh - 106px)"};
    width: 100%;

    &:after {
      content: '';
      width: 100vw;
      height: 100px;
      background-color: rgba(21, 21, 21, 0.75);
      position: absolute;
      top: 46px;
      left: 0;
    }
  `}
`;

export const NotificationsLink = styled.a`
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.02em;
  color: #333333 !important;
  display: flex;
  align-items: center;

  .bell.icon {
    font-size: 1.3em !important;
    margin-right: 10px;
    color: #79D9D9;
  }

  &:hover {
    color: #402680 !important;
  }
`;
